const React = require('react');

const Columns = require('../layout/Columns.jsx');
const Name = require('../utility/Name.jsx');
const _TypeConfig = require('./TypeConfig.jsx');

// #region V1

function NonBreakingContainer(props) {
    let className = 'pageBreakInsideAvoid';
    if (props.className) {
        className += ` ${props.className}`;
    }
    return (
        <Columns.V1.Component
            {...props}
            className={className}
            dataType="container"
            renderHeader={false} />
    );
}

const TypeConfig = {
    panel: {
        block: function () {
            return {
                options: [
                    { name: 'col1_width', value: '100', visible: function () { return false; } }
                ]
            };
        },
        columns: function () { return [[]]; },
        style: function () { return _TypeConfig.panel.layoutStyle({}, undefined, {}); }
    }
};

// #endregion V1

// #region V2

function NonBreakingContainerV2(props) {
    let className = 'pageBreakInsideAvoid';
    if (props.className) {
        className += ` ${props.className}`;
    }
    return (
        <Columns.V2.Component
            {...props}
            blockType={Name.Block.NonBreakingContainer}
            className={className}
            dataType="layout"
            renderHeader={false} />
    );
}

const TypeConfigV2 = {
    panel: {
        block: () => {
            return {
                options: [
                    { name: 'columnCount', value: '1', visible: () => false },
                    { name: 'width-col1', value: { unit: '%', value: '100' }, visible: () => false }
                ]
            };
        },
        style: () => _TypeConfig.panel.layoutStyleV2('block', 'Layout', {}, undefined, {})
    }
};

// #endregion V2

module.exports = {
    V1: {
        Component: NonBreakingContainer,
        TypeConfig
    },
    V2: {
        Component: NonBreakingContainerV2,
        TypeConfig: TypeConfigV2
    }
};